module.exports = __webpack_public_path__ + "img/SMT_33_Mr_David_Wong.f7d608f1.jpg";